import {
    DialogActionButton,
    saveCallbackStatus,
  } from '@finpay-development/shared-components';
  import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
  } from '@mui/material';
  
  interface EstAttachToIocConfirmModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
    isConfirming?: boolean;
  }
  
  export function EstAttachToIocConfirmModal({
    open,
    onClose,
    onConfirm,
    isConfirming = false,
  }: EstAttachToIocConfirmModalProps) {
    return (
      <Dialog
        className="modal"
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        scroll="body"
        test-id="estimate-tab-attach-ioc-warning-modal"
      >
        <DialogTitle>Attach to Instance of Care</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Are you sure you want to change the Instance of Care to use this estimate?
          </Typography>
        </DialogContent>
        <DialogActions test-id="estimate-tab-attach-ioc-dialog-actions">
          <DialogActionButton
            isEnabled={!isConfirming}
            savebuttonText="Confirm"
            saveStatus={saveCallbackStatus.none}
            executeSave={onConfirm}
            handleCallbackSave={() => {}}
            handleCallbackCancel={onClose}
            test-id="estimate-tab-attach-ioc-confirm-button"
          />
        </DialogActions>
      </Dialog>
    );
  }
